import React from 'react';
import { useContext } from 'react';
import { TransactionFilterContext } from 'src/context/transaction-filter-context';

import { formatStartDate, formatEndDate } from 'src/helpers/formatting';

export default function TransactionDateFilterCriteria() {
  const { transactionFilter } = useContext(TransactionFilterContext);

  const fromDate = transactionFilter?.selectedDates[0];
  const toDate = transactionFilter?.selectedDates[1];

  return (
    <div className="search-criteria-container" data-testid="search-criteria-date">
      {formatStartDate(fromDate)} - {formatEndDate(toDate)}
    </div>
  );
}